import React from 'react';

export const AppVersion: React.FC = () => {
  return (
    <span>
      v{ process.env.REACT_APP_VERSION }
    </span>
  )
}